import { Turbo } from "@hotwired/turbo-rails"
import { formatUtcDateForParam } from "../shared/date"

// Öffnet die Depot-Detailansicht in einem Turbo Frame.
// `zeitpunktUtcMs` ist ein UTC-Timestamp (ms) aus Highcharts.
// `frameId` ist die DOM-id des Turbo Frames, in den die Detailansicht geladen werden soll
// (z.B. dom_id(@depot, :modal_klein)).
export function openDepotDetail({ url, zeitpunktUtcMs, anzeigeformat, chartType, frameId }) {
	const datumString = formatUtcDateForParam(zeitpunktUtcMs)
	const params = new URLSearchParams({ zeitpunkt: datumString, chart_type: chartType, anzeigeformat: anzeigeformat })
	const fullUrl = `${url}?${params.toString()}`

	// Preferred: navigate within the Turbo Frame so the server can answer with normal HTML.
	if (frameId) {
		Turbo.visit(fullUrl, { frame: frameId })
		return
	}

	// Fallback: normal navigation.
	Turbo.visit(fullUrl)
}
